import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon } from './icons';
import { useLanguage } from '../context/LanguageContext';
export function RiskReversal() {
  const {
    t
  } = useLanguage();
  return <section id="garantia" className="py-12 bg-brand-bg-dark relative overflow-hidden" data-id="element-272">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'repeating-linear-gradient(45deg, #D4860A 0, #D4860A 1px, transparent 0, transparent 50%)',
      backgroundSize: '20px 20px'
    }} data-id="element-273"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-274">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-275">
          <div className="bg-gradient-to-br from-brand-gold-dark/20 to-brand-bg-dark border-2 border-brand-gold rounded-2xl p-8 sm:p-12 md:p-16 shadow-[0_0_50px_rgba(200,169,81,0.15)] text-center" data-id="element-276">
            <div className="flex justify-center mb-8" data-id="element-277">
              <div className="bg-brand-gold/10 p-4 rounded-full border border-brand-gold/30" data-id="element-278">
                <ShieldIcon className="w-16 h-16 text-brand-gold" data-id="element-279" />
              </div>
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white mb-10 uppercase tracking-widest" data-id="element-280">
              {t('risk.title')}
            </h2>

            <div className="space-y-8" data-id="element-281">
              <p className="text-2xl sm:text-3xl font-medium text-gray-200 leading-relaxed max-w-3xl mx-auto" data-id="element-282">
                {t('risk.p1')}
                <strong className="text-brand-gold font-heading" data-id="element-283">
                  {t('risk.p1_strong')}
                </strong>
              </p>

              <p className="text-xl sm:text-2xl text-brand-red font-bold uppercase tracking-wider" data-id="element-284">
                {t('risk.p2')}
              </p>

              <div className="w-24 h-1 bg-brand-gold mx-auto my-8 rounded-full" data-id="element-285"></div>

              <p className="text-xl text-gray-400 italic" data-id="element-286">{t('risk.p3')}</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}